interface IProps {
  doc: any
}
export default function TOCModel1({ doc }: IProps) {
  return (
    <div className="flex h-full">
      <div className="h-full w-[72px] min-w-[40px] bg-[#4A9AA7] rounded-lg mr-5" />
      <div className="flex flex-col justify-between w-full h-full">
        {/* Main Title Section */}
        <div className="flex flex-col text-left w-full">
          <h2 className="text-3xl font-extrabold uppercase">Table Of Content</h2>
          <div className="mt-20">
            <ul className="space-y-3 h-full overflow-y-auto pr-2">
              {doc.sections.map((section: any, index: number) => (
                <li key={index} className="flex items-start text-md font-medium text-gray-700 transition duration-200">
                  <span className="mr-2 text-gray-500">{index + 1}.</span>
                  <span>{section.title}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
